import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import * as S from './styles';

const InfoContainer = ({
  eventDate,
  eventEndDate,
  location,
  destination,
  primaryColor,
}) => {
  const [t] = useTranslation('personalized-invite');

  const eventPeriod = eventEndDate
    ? t('date-range', { start: eventDate, end: eventEndDate })
    : eventDate;

  return (
    <S.Wrapper>
      <S.InfoCard>
        <S.IconWrapper>
          <S.DateIcon size={20} color={primaryColor} />
        </S.IconWrapper>
        <S.InfoContent>
          <S.Label>{t('date')}</S.Label>
          <S.DateValue>{eventPeriod}</S.DateValue>
        </S.InfoContent>
      </S.InfoCard>

      <S.InfoCard>
        <S.IconWrapper>
          <S.LocationIcon size={20} color={primaryColor} />
        </S.IconWrapper>
        <S.InfoContent>
          <S.Label>{t('location')}</S.Label>
          <S.LocationName>{location.name}</S.LocationName>
          <S.LocationAddress
            href={location.mapsUrl}
            color={primaryColor}
            target="_blank"
            rel="noreferrer"
          >
            {location.address}
          </S.LocationAddress>
        </S.InfoContent>
      </S.InfoCard>

      <S.InfoCard>
        <S.IconWrapper>
          <S.DestinationIcon size={20} color={primaryColor} />
        </S.IconWrapper>
        <S.InfoContent>
          <S.Label>{t('destination')}</S.Label>
          <S.Value>{destination}</S.Value>
        </S.InfoContent>
      </S.InfoCard>
    </S.Wrapper>
  );
};

InfoContainer.propTypes = {
  eventDate: propTypes.string.isRequired,
  eventEndDate: propTypes.string,
  location: propTypes.shape({
    name: propTypes.string,
    address: propTypes.string,
    mapsUrl: propTypes.string,
  }).isRequired,
  destination: propTypes.string.isRequired,
  primaryColor: propTypes.string.isRequired,
};

InfoContainer.defaultProps = {
  eventEndDate: '',
};

export default InfoContainer;
